<template>
    <div class="v_login g-flex-column g-flex-align-center g-flex-justify-center">
        <div class="v-login-logo g-flex-align-center">
            <img src="/img/logo.png" alt="">
            <p>{{$global.config.web_title}}</p>
        </div>
        <div class="v-form-box g-flex-align-center g-flex-justify-center">
            <img :src="imgUrl" alt="">
            <el-form ref="form" :model="form" :rules="rules" class="v-form g-flex-column g-flex-align-start">
                <h3 class="v-login-title">欢迎登录</h3>
                <p class="v-login-tip">如果您有任何疑问，请随时与我们联系，给予你最便捷的生活态度</p>
                <el-form-item prop="user_name">
                    <el-input type="text" placeholder="请输入账号" v-model="form.user_name" autocomplete="off" prefix-icon="iconfont icon-user"/>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input :type="isPwdType ? 'password': ''"  placeholder="请输入密码" v-model="form.password" @keyup.enter.native="login" autocomplete="off">
                         <i slot="prefix" class="iconfont icon-mima"></i>
                         <i slot="suffix" @click="toggleType" class="iconfont" :class="isPwdType ? 'icon-bukejian' : 'icon-mimakejianguanbi'"></i>
                    </el-input>
                </el-form-item>
                <el-button type="primary" @click="login">登录</el-button>
            </el-form>
        </div>

    </div>
</template>

<script>
    import { apiLogin, apiInit, apiGetConfig } from '@/utils/api.js'
    export default {
        name: 'Login',
        data() {
            return {
                imgUrl: require('../../assets/img/login_form_img.png'),
                
                isPwdType: true,
                
                form: {
                    user_name: '',
                    password: ''
                },

                // 表单验证，需要在 el-form-item 元素中增加 prop 属性
                rules: {
                    user_name: [
                        {required: true, message: '账号不可为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不可为空', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.apiGetConfigHandel()
        },
        methods: {
            async apiGetConfigHandel() {
                const { success, data } = await apiGetConfig()
                if(!success) return
                this.$global.config.web_title = data.data.web_title
            },    

            toggleType() {
                this.isPwdType = !this.isPwdType
            },

            login() {
                // 表单绑定验证功能
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        const loading = this.$loading()
                        const { success, data } = await apiLogin(this.form).catch(()=> {
                            loading.close()
                        })
                        if(!success) return loading.close()
                        localStorage.setItem('adminToken',data.token)
                        this.$global.token = data.token
                        this.$ws.setToken(data.token)
                        loading.close()
                        this.$router.replace('/')
                    } else {
                        return false;
                    }
                })
            },

            async apiInitHandel() {
              const { success, data } = await apiInit()
              if(!success) return
              this.$global.adminUser = data.user
            }
        }
    }
</script>

<style lang="scss">
    .v_login {
        background: url("/img/login_bg.jpg") no-repeat;
        background-position: center;
        background-size: cover;
        width:100%;
        height:100%;
        .v-login-logo {
            padding-bottom: 16px;
            p {
                padding-left: 6px;
                font-size: 40px;
                color: #007AFF;
            }
        }
        .v-form-box {
            background-color: rgba($color: #fff, $alpha: 0.7);
            border: 1px solid #DCDFE6;
            width: 960px;
            height: 550px;
            border-radius: 20px;

            img {
                width: 346px;
                height: 254px;
                object-fit: cover;
                vertical-align: middle;
            }
            
            .v-form {
                padding-left: 100px;
                .el-button {
                    background: #007AFF;
                    width: 100%;
                }
                .el-form-item {
                    width: 100%;
                    .el-input {
                        color: #B5B5B5;
                        .el-input__inner {
                            border: 1px solid #7cbbff;
                            border-radius: 8px;
                            padding-left: 40px;
                            padding-right: 40px;
                        }
                        .el-input__prefix {
                            i {
                                font-size: 26px;
                            }
                        }
                        .el-input__suffix {
                            i {
                                font-size: 26px;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .v-login-title {
                    font-size: 28px;
                    text-align: center;
                    font-weight: normal;
                    color: #007AFF;
                    margin: 0;
                    padding: 0;
                    padding-bottom: 20px;
                }
                .v-login-tip {
                    font-size: 12px;
                    color: #B5B5B5;
                    padding-bottom: 28px;
                }
            }
        }
    }
</style>